import { watchPayPro } from './payPro';

export const watchHealth = [
    ...watchPayPro,
];
